module.exports = __webpack_public_path__ + "static/media/Kiosk-Compact-wht.4ef92d77.png";